module.exports = __webpack_public_path__ + "c1edb3274991bc6f90cf8d278e384e23.png";